export const maxMobileViewportWidth = 640
export const mainContainerTabletWidth = 620
export const mainContainerDesktopWidth = 700
